// PE-6337 — require GCP outer Base64(UTF-8(aesKey)); reject plain AES key strings

/**
 * PE-6337 — Resolve AES-GCM transport key from config.
 * Accepts only outer Base64(UTF-8(plainKey)). Plain Base64-32-byte keys are rejected.
 *
 * @returns inner plain AES key (Base64 of 32 bytes), or null if missing / plain / corrupt
 */
export function resolveAesGcmKey(configured: string | null | undefined): string | null {
  if (configured == null) {
    return null;
  }
  const trimmed = configured.trim();
  if (!trimmed) {
    return null;
  }
  // Plain key Base64-decodes to 32 binary bytes — reject (must be outer-wrapped)
  if (isValidAesKeyBase64(trimmed)) {
    return null;
  }
  let inner: string;
  try {
    const decoded = atob(trimmed);
    if (!decoded.length || !isPrintableAscii(decoded)) {
      return null;
    }
    inner = decoded.trim();
  } catch {
    return null;
  }
  if (!inner || inner === trimmed || !isValidAesKeyBase64(inner)) {
    return null;
  }
  return inner;
}

export function isValidAesKeyBase64(value: string | null | undefined): boolean {
  if (value == null || !value.trim()) {
    return false;
  }
  try {
    const raw = atob(value.trim());
    return raw.length === 32;
  } catch {
    return false;
  }
}

function isPrintableAscii(s: string): boolean {
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    if (c < 0x20 || c > 0x7e) {
      return false;
    }
  }
  return true;
}
